<template>
  <span v-if="value !== 0" class="change-pill" :class="value > 0 ? 'up' : 'down'">
    <svg v-if="value > 0" viewBox="0 0 12 12" fill="none">
      <path d="M6 9V3M6 3L3 6M6 3L9 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <svg v-else viewBox="0 0 12 12" fill="none">
      <path d="M6 3V9M6 9L3 6M6 9L9 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    {{ Math.abs(value).toFixed(2) }}%
  </span>
</template>

<script>
export default {
  name: "ChangePill",
  props: {
    change: { type: [Number, String], default: 0 },
  },
  computed: {
    value() {
      const n = parseFloat(this.change);
      return Number.isFinite(n) ? n : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.change-pill {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 7px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;

  svg {
    width: 11px;
    height: 11px;
  }

  &.up {
    color: #4d84ff;
    background: rgba(77, 132, 255, 0.1);
  }

  &.down {
    color: #e84343;
    background: rgba(232, 67, 67, 0.1);
  }
}
</style>
